import ActuatorACSPService from '@/services/actuator.acsp.service';
import ActuatorACPService from '@/services/actuator.acp.service';
import ActuatorASService from '@/services/actuator.as.service';
import actuatorASautoService from '@/services/actuator.asAuto.service';

export default class Actuator {
    public id!: string;
    public revision?: string;
    public tag!: string;
    public pos!: string;
    public posCustomer?: string;
    public quantity!: number;
    public driveType!: string;
    public controlType!: string;
    public driveTypeA!: string;
    public selectedDriveTypeAOptions!: string[];
    public pressureMin!: number;
    public pressureNorm!: number;
    public pressureMax!: number;
    public bto!: number;
    public btoAngle!: number;
    public btoSecFac!: number;
    public eto!: number;
    public etoAngle!: number;
    public etoSecFac!: number;
    public btc!: number;
    public btcAngle!: number;
    public btcSecFac!: number;
    public etc!: number;
    public etcAngle!: number;
    public etcSecFac!: number;
    public running!: number;
    public runningAngle!: number;
    public runningSecFac!: number;
    public runningOut!: number;
    public runningOutAngle!: number;
    public runningOutSecFac!: number;
    public mast!: boolean;
    public tolerance!: number;
    public items!: number;
    public myInterpretation?: any;
    public label?: any;
    public valveSize: string;
    public valveClass: string;
    public valveMast?: number;
    public strokeTimeOpen?: string;
    public strokeTimeClose?: string;
    public strokeTimeOpenMOD?: string;
    public strokeTimeCloseMOD?: string;
    public controlFunction?: string;
    public zylinderVolumenP?: number;
    public safetyFunctionByPressFailure?: string;
    public safetyFunctionByPowerFailure?: string;
    public torques?: any;
    public isDeleted: boolean = false;
    public temperature?: string;
    public manuelOverride?: string;

    public constructor() {
        this.tag = 'HV-60...';
        this.pos = '0';
        this.quantity = 1;
        this.valveSize = '';
        this.valveClass = '200';
        this.driveType = 'SC';
        this.controlType = 'P';
        this.driveTypeA = '';
        this.selectedDriveTypeAOptions = [];
        this.pressureMin = 3;
        this.pressureNorm = 6;
        this.pressureMax = 8;
        this.items = 1;
        this.mast = false;
        this.tolerance = 0;
        this.btoAngle = 0;
        this.btoSecFac = 1.5;
        this.runningAngle = 0;
        this.runningSecFac = 1.5;
        this.etoAngle = 0;
        this.etoSecFac = 1.5;
        this.btcAngle = 0;
        this.btcSecFac = 1.5;
        this.runningOutAngle = 0;
        this.runningOutSecFac = 1.5;
        this.etcAngle = 0;
        this.etcSecFac = 1.5;
        this.myInterpretation = '{}';
        this.strokeTimeOpen = '';
        this.strokeTimeClose = '';
        this.strokeTimeOpenMOD = '';
        this.strokeTimeCloseMOD = '';
        this.controlFunction = '';
        this.zylinderVolumenP = 0;
        this.safetyFunctionByPressFailure = '';
        this.safetyFunctionByPowerFailure = '';
        this.torques = '';
        this.temperature = '';
        this.manuelOverride = '';
    }

    public static parseRawFromArray(array: Array<any>, preDefined: any): Actuator {
        const actuator = new Actuator();
        actuator.pos = array[0];

        actuator.posCustomer = array[1];
        actuator.quantity = array[3];

        actuator.bto = array[7];
        actuator.running = array[8];
        actuator.eto = array[9];
        actuator.btc = array[10];
        actuator.runningOut = array[11];
        actuator.etc = array[12];

        actuator.btoSecFac = array[29];
        actuator.runningSecFac = array[30];
        actuator.etoSecFac = array[31];
        actuator.btcSecFac = array[32];
        actuator.runningOutSecFac = array[33];
        actuator.etcSecFac = array[34];

        actuator.btoAngle = (array[20] === '-' || array[20] === '' || isNaN(array[20])) ? 0 : array[20];
        actuator.runningAngle = (array[21] === '-' || array[21] === '' || isNaN(array[21])) ? 90 : array[21];
        actuator.etoAngle = (array[22] === '-' || array[22] === '' || isNaN(array[22])) ? 90 : array[22];
        actuator.btcAngle = (array[23] === '-' || array[23] === '' || isNaN(array[23])) ? 90 : array[23];
        actuator.runningOutAngle = (array[24] === '-' || array[24] === '' || isNaN(array[24])) ? 0 : array[24];
        actuator.etcAngle = (array[25] === '-' || array[25] === '' || isNaN(array[25])) ? 0 : array[25];

        actuator.pressureMin = array[26];
        actuator.pressureNorm = array[27];
        actuator.pressureMax = array[28];

        actuator.valveMast = !isNaN(array[13]) ? array[13] : 0;

        actuator.tag = array[2];
        actuator.valveSize = array[4];
        actuator.valveClass = array[5];
        actuator.safetyFunctionByPressFailure = array[36];
        actuator.safetyFunctionByPowerFailure = array[37];
        if (array[36] === 'Fail Last' || array[36] === 'Fail Lock') {
            actuator.driveType = 'DA';
        } else if (array[36] === 'Fail Close') {
            actuator.driveType = 'SC';
        } else {
            actuator.driveType = 'SO';
        }
        // actuator.driveType = preDefined.driveType;
        actuator.selectedDriveTypeAOptions = this.siktir(preDefined.selectedDriveTypeAOptions);
        actuator.controlType = array[35];
        // actuator.driveTypeA = preDefined.driveTypeA;
        actuator.label = '';
        actuator.mast = preDefined.mast;
        actuator.tolerance = preDefined.tolerance;
        actuator.strokeTimeOpen = array[38].toString();
        actuator.strokeTimeClose = array[39].toString();
        actuator.strokeTimeOpenMOD = array[40].toString();
        actuator.strokeTimeCloseMOD = array[41].toString();
        actuator.controlFunction = array[43].toString();
        actuator.temperature = array[44].toString(); // ST, LT, ET
        actuator.manuelOverride = array[45].toString(); // HW, HP
        actuator.myInterpretation = '{}';
        actuator.torques = '';
        return actuator;
    }

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<Actuator>): Actuator {
        const actuator = new Actuator();
        Object.assign(actuator, object);
        return actuator;
    }

    public static parseFromArray(array?: Partial<Actuator>[]): Actuator[] {
        if (!array) {
            return [];
        }

        return array.map((act) => Actuator.parseFromObject(act));
    }

    parseToObject(): any {
        return { ...this };
    }

    public static siktir(options: string[]) {
        const driveTypeOptions: string[] = ['ACSP', 'ACP', 'AS'];
        const empt: string[] = [];
        for (let index = 0; index < driveTypeOptions.length; index++) {
            if (options.find(element => element === driveTypeOptions[index])) {
                empt.push(driveTypeOptions[index]);
            }
        }
        return empt;
    }

    public async interpret(driveTypeA?: string) {
        const interpretationResult: any = {
            acsp: {},
            acp: {},
            asS: {},
            asC: {},
            as: {}
        };

        if (driveTypeA) {
            this.driveTypeA = driveTypeA;

            if (driveTypeA === 'ACSP') {
                interpretationResult.acsp = ActuatorACSPService.getMasterACSP(this);
                if (interpretationResult.acsp.found) {
                    // console.log(interpretationResult.acsp.antrieb);

                    this.label = interpretationResult.acsp.antrieb.label;
                    this.torques = JSON.stringify(interpretationResult.acsp.antrieb.antriebDrehsObj);
                    this.myInterpretation = JSON.stringify(interpretationResult.acsp.antrieb);
                } else {
                    this.label = interpretationResult.acsp.reason;
                }

            } else if (driveTypeA === 'ACP') {
                interpretationResult.acp = ActuatorACPService.getMasterACP(this);
                if (interpretationResult.acp.found) {
                    this.label = interpretationResult.acp.antrieb.label;
                    this.zylinderVolumenP = interpretationResult.acp.antrieb.zylinderVolumenP;
                    // console.log(interpretationResult.acp.antrieb);
                    this.torques = JSON.stringify(interpretationResult.acp.antrieb.antriebDrehsObj);
                    this.myInterpretation = JSON.stringify(interpretationResult.acp.antrieb);
                } else {
                    this.label = interpretationResult.acp.reason;
                }
            } else if (driveTypeA === 'AS-S' || driveTypeA === 'AS-C') {
                if (driveTypeA === 'AS-S') {
                    interpretationResult.asS = ActuatorASService.getMasterAS(this);
                    console.log('interpretationResult.asS', interpretationResult.asS);
                    if (interpretationResult.asS.found) {
                        // console.log(interpretationResult.asS.antrieb);
                        this.label = interpretationResult.asS.antrieb.label;
                        this.zylinderVolumenP = interpretationResult.asS.antrieb.zylinderVolumenP;
                        this.torques = JSON.stringify(interpretationResult.asS.antrieb.antriebDrehsObj);
                        this.myInterpretation = JSON.stringify(interpretationResult.asS.antrieb);
                        // this.myInterpretation = '';
                    } else {
                        this.label = interpretationResult.asS.reason;
                    }
                } else {
                    interpretationResult.asC = ActuatorASService.getMasterAS(this);
                    if (interpretationResult.asC.found) {
                        // console.log(interpretationResult.asC.antrieb);
                        this.label = interpretationResult.asC.antrieb.label;
                        this.zylinderVolumenP = interpretationResult.asC.antrieb.zylinderVolumenP;
                        this.torques = JSON.stringify(interpretationResult.asC.antrieb.antriebDrehsObj);
                        this.myInterpretation = JSON.stringify(interpretationResult.asC.antrieb);
                    } else {
                        this.label = this.label = interpretationResult.asC.reason;
                    }
                }
            } else if (driveTypeA === 'AS') {
                interpretationResult.as = actuatorASautoService.getMasterASauto(this);
                if (interpretationResult.as.found) {
                    this.label = interpretationResult.as.antrieb.label;
                    this.zylinderVolumenP = interpretationResult.as.antrieb.zylinderVolumenP;
                    this.torques = JSON.stringify(interpretationResult.as.antrieb.antriebDrehsObj);
                    this.myInterpretation = JSON.stringify(interpretationResult.as.antrieb);
                } else {
                    this.label = interpretationResult.as.reason;
                }
            }
        } else {
            let found = false;
            for (const actuatorType of this.selectedDriveTypeAOptions) {

                if (actuatorType === 'ACSP') {
                    // TODO: Torben infinite loop kacke
                    this.driveTypeA = actuatorType;
                    interpretationResult.acsp = ActuatorACSPService.getMasterACSP(this);
                    if (interpretationResult.acsp.found) {
                        // console.log(interpretationResult.acsp.antrieb);

                        this.label = interpretationResult.acsp.antrieb.label;
                        this.torques = JSON.stringify(interpretationResult.acsp.antrieb.antriebDrehsObj);
                        this.myInterpretation = JSON.stringify(interpretationResult.acsp.antrieb);
                        found = true;
                    } else {
                        this.label = interpretationResult.acsp.reason;
                    }

                } else if (actuatorType === 'ACP') {
                    this.driveTypeA = actuatorType;
                    interpretationResult.acp = ActuatorACPService.getMasterACP(this);
                    if (interpretationResult.acp.found) {
                        this.label = interpretationResult.acp.antrieb.label;
                        this.zylinderVolumenP = interpretationResult.acp.antrieb.zylinderVolumenP;
                        // console.log(interpretationResult.acp.antrieb);
                        this.torques = JSON.stringify(interpretationResult.acp.antrieb.antriebDrehsObj);
                        this.myInterpretation = JSON.stringify(interpretationResult.acp.antrieb);
                        found = true;
                    } else {
                        this.label = interpretationResult.acp.reason;
                    }
                } else if (actuatorType === 'AS-S' || actuatorType === 'AS-C') {
                    if (actuatorType === 'AS-S') {
                        this.driveTypeA = 'AS-S';
                        interpretationResult.asS = ActuatorASService.getMasterAS(this);
                        if (interpretationResult.asS.found) {
                            // console.log(interpretationResult.asS.antrieb);
                            this.label = interpretationResult.asS.antrieb.label;
                            this.zylinderVolumenP = interpretationResult.asS.antrieb.zylinderVolumenP;
                            this.torques = JSON.stringify(interpretationResult.asS.antrieb.antriebDrehsObj);
                            this.myInterpretation = JSON.stringify(interpretationResult.asS.antrieb);
                            found = true;
                            // this.myInterpretation = '';
                        } else {
                            this.label = interpretationResult.asS.reason;
                        }
                    } else {
                        this.driveTypeA = 'AS-C';
                        interpretationResult.asC = ActuatorASService.getMasterAS(this);
                        if (interpretationResult.asC.found) {
                            // console.log(interpretationResult.asC.antrieb);
                            this.label = interpretationResult.asC.antrieb.label;
                            this.zylinderVolumenP = interpretationResult.asC.antrieb.zylinderVolumenP;
                            this.torques = JSON.stringify(interpretationResult.asC.antrieb.antriebDrehsObj);
                            this.myInterpretation = JSON.stringify(interpretationResult.asC.antrieb);
                            found = true;
                        } else {
                            this.label = this.label = interpretationResult.asC.reason;
                        }
                    }
                } else if (actuatorType === 'AS') {
                    this.driveTypeA = 'AS';
                    interpretationResult.as = actuatorASautoService.getMasterASauto(this);
                    if (interpretationResult.as.found) {
                        this.label = interpretationResult.as.antrieb.label;
                        this.zylinderVolumenP = interpretationResult.as.antrieb.zylinderVolumenP;
                        this.torques = JSON.stringify(interpretationResult.as.antrieb.antriebDrehsObj);
                        this.myInterpretation = JSON.stringify(interpretationResult.as.antrieb);
                        found = true;
                    } else {
                        this.label = interpretationResult.as.reason;
                    }
                }
                if (found) break;
            }
        }
    }

    public checkInputsForempty(this: any) {
        this.btc = (this.btc === '') ? 0 : this.btc;
        this.bto = (this.bto === '') ? 0 : this.bto;
        this.etc = (this.etc === '') ? 0 : this.etc;
        this.eto = (this.eto === '') ? 0 : this.eto;
        this.running = (this.running === '') ? 0 : this.running;
        this.runningOut = (this.runningOut === '') ? 0 : this.runningOut;
        this.pressureMin = (this.pressureMin === '') ? 0 : this.pressureMin;
        this.pressureMax = (this.pressureMax === '') ? 0 : this.pressureMax;
        this.pressureNorm = (this.pressureNorm === '') ? 0 : this.pressureNorm;
        this.btoSecFac = (this.btoSecFac === '') ? 1 : this.btoSecFac;
        this.runningSecFac = (this.runningSecFac === '') ? 1 : this.runningSecFac;
        this.etoSecFac = (this.etoSecFac === '') ? 1 : this.etoSecFac;
        this.btcSecFac = (this.btcSecFac === '') ? 1 : this.btcSecFac;
        this.runningOutSecFac = (this.runningOutSecFac === '') ? 1 : this.runningOutSecFac;
        this.etcSecFac = (this.etcSecFac === '') ? 1 : this.etcSecFac;

    }

    public getLabel() {
        return 'mahmutJunus';
    }
}
